import { ApiEndpoints } from "@shared/api/api-endpoints";
import { AddHelpfullPayload } from "./types";
import { cxApiClient, onboardingApiClient, mxApiClient } from "@shared/api/clients/apiClientFactory";

export const consumptionApi = {
  getTipsData: async (params: {
    remote_utility_id: string;
    utility_service: any;
    show_inactive: any;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/tips",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        if (params.utility_service) {
          qs.push("utility_service", params.utility_service);
        }
        qs.push("show_inactive", params.show_inactive);
      }
    );
    const response = await onboardingApiClient.get(url); 
    return response.data;
  },
  
  addHelpful: async (payload: AddHelpfullPayload): Promise<any> => {
    const url = ApiEndpoints.createUrl("consumerWeb", "consumer-tips-status");
    const response = await cxApiClient.post(url, payload);
    return response.data;
  },

  getConsumerConsumptionKpi: async (params: {
    remote_utility_id: string;
    consumer_no: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "mx",
      "consumer-consumption-kpi",
      (qs) => {
        if (params.remote_utility_id) qs.push("remote_utility_id", params.remote_utility_id);
        if (params.consumer_no) qs.push("consumer_no", params.consumer_no);
      }
    );
    const response = await mxApiClient.get(url);
    return response.data;
  }
};
